import Vue from 'vue';
import axios from 'axios'; 

export default {
  name: 'Webgis',
  data: function () {
    return {
      message: '',
      indicatePointsTitle: 'To change',
      showDialog: false,
      frameSrc: '',
    }
  },
  created() {
    //this.openGIS();
  },
  methods: {
    openGIS() {
      axios.post('/GIS/GetGISUrl')
        .then(response => {
          if (response.data.data.status == 0) {
            var url = response.data.url;
            window.open(url, 'blank');
            this.$router.go(-1);
          }
          else
            this.closeWithMessage(response.data.data.text, 1);
        })
        .catch(e => { this.$router.push('/login'); return false; })

      //var link = 'http://localhost/WebGisGeo/MapView.aspx?UserName=hcs&Password=hcs&Map=LWB';
      //var link = 'http://localhost/WebGisGeo/MapView.aspx?UserName=hcs&Password=hcs&Map=LWB&ZoomLayer=edams_geo_water_connection&Key=DATA&Value=10';

    },
    zoomElement() {
      axios.post('/GIS/GetZoomToElementUrl', { ElementType: 0, ElementId: 3 })
        .then(response => {
          if (response.data.data.status == 0) {
            var url = response.data.url;
            window.open(url, 'blank');
            this.$router.go(-1);
          }
          else
            this.closeWithMessage(response.data.data.text, 1);
        })
        .catch(e => { this.$router.push('/login'); return false; })

      //var link = 'http://localhost/WebGisGeo/MapView.aspx?UserName=hcs&Password=hcs&Map=LWB';
      //var link = 'http://localhost/WebGisGeo/MapView.aspx?UserName=hcs&Password=hcs&Map=LWB&ZoomLayer=edams_geo_water_connection&Key=DATA&Value=10';

    },
    insertPoint()
    {
      axios.post('/GIS/GetInsertElementUrl', { Value: 0 })
        .then(response => {
          if (response.data.data.status == 0) {
            this.frameSrc = response.data.url;
            this.showDialog = true;
          }
          else
            this.closeWithMessage(response.data.data.text, 1);
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    insertLine() {
      axios.post('/GIS/GetInsertElementUrl', { Value: 1 })
        .then(response => {
          if (response.data.data.status == 0) {
            this.frameSrc = response.data.url;
            this.showDialog = true;
          }
          else
            this.closeWithMessage(response.data.data.text, 1);
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    indicatePointCallBack(lat, lon) {
      console.log(lat, lon);
      //$("#_hfSelectedLocation").val(lat + ';' + lon);

      //// force gis user to logout
      //var frm = $get('<%=_frame.ClientID %>');
      //frm.src = '';
      //window.setTimeout('$("#_modalWindowGIS").modal("hide")', 200);
      this.showDialog = false;
    },
    geometryInserted(coords) {
      console.log(coords);
      //$("#_hfSelectedLocation").val(coords);

      //// force gis user to logout
      //var frm = $get('<%=_frame.ClientID %>');
      //frm.src = '';
      //window.setTimeout('$("#_modalWindowGIS").modal("hide")', 200);
    },
    close() {
      ;
    },
    closeWithMessage(msg, type, timeout = 3000) {
      this.message = msg;
      if (type == 1)
        this.message += ' If the problem repeats please contact Support';
      this.$alertMsg(msg);
      setTimeout(function () { this.close(); }.bind(this), timeout);
    },
  }
}
